import * as React from 'react';
import CardFull from '@src/components/Cards/CardFull';
import CardSection from '@src/components/CardSection';
import CardSmall from '@src/components/Cards/CardSmall';
import PageSection from '@src/components/PageSection';
import {graphql} from 'gatsby';

import type {ArticleCardFragment} from '@graphql-types';

export interface ArticleCardProps {
  slice: ArticleCardFragment;
}

const ArticleCards: React.FC<ArticleCardProps> = ({slice}) => {
  const primaryArticle =
    slice.primary.article?.document && 'uid' in slice.primary.article.document
      ? slice.primary.article.document
      : null;
  const primaryArticleImage = primaryArticle
    ? primaryArticle.data.image.thumbnails.card_large ||
      primaryArticle.data.image
    : null;

  return (
    <PageSection>
      <CardSection>
        {primaryArticle && (
          <CardFull
            heading={primaryArticle.data.title.text}
            text={primaryArticle.data.subtitle.text}
            linkUrl={slice.primary.article.url}
            backgroundImageUrl={
              primaryArticleImage ? primaryArticleImage.url : null
            }
          />
        )}

        {slice.items.map(({article}) => {
          if (article?.document && 'uid' in article.document) {
            return (
              <CardSmall
                key={article.document.uid}
                heading={article.document.data.title.text}
                text={article.document.data.subtitle.text}
                linkUrl={article.url}
                backgroundImageUrl={
                  article.document?.data?.image?.thumbnails?.card_small?.url ||
                  article.document?.data?.image?.url ||
                  null
                }
              />
            );
          }
        })}
      </CardSection>
    </PageSection>
  );
};

export default ArticleCards;

export const articleCardQuery = graphql`
  fragment articleCard on PrismicPageDataBodyArticleCards {
    id
    slice_type
    primary {
      article {
        url
        document {
          ... on PrismicArticle {
            uid
            data {
              title {
                text
              }
              subtitle {
                text
              }
              image {
                url
                thumbnails {
                  card_small {
                    url
                  }
                  card_large {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
    items {
      article {
        url
        document {
          ... on PrismicArticle {
            uid
            data {
              title {
                text
              }
              subtitle {
                text
              }
              image {
                url
                thumbnails {
                  card_small {
                    url
                  }
                  card_large {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
